import {StringOrNumber} from "./StringOrNumber";

export const uniqueArrayItem = <T extends StringOrNumber>(input: T, index: number, array: T[]):
    boolean => array.indexOf(input) === index;
